import { render, staticRenderFns } from "./RaiseRequestHistory.vue?vue&type=template&id=acc6890c"
import script from "./RaiseRequestHistory.vue?vue&type=script&lang=js"
export * from "./RaiseRequestHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports